document.addEventListener("DOMContentLoaded", function() {
  // Get all radio inputs inside the subscription container
  const radioButtons = document.querySelectorAll('.shopify_subscriptions_fieldset input[type="radio"]');

  radioButtons.forEach((radio) => {
    // Add the 'checked' class to the label if the radio button is selected on page load
    if (radio.checked) {
      radio.closest('label').classList.add('checked');
    }

    // Add event listener to each radio button for changes
    radio.addEventListener("change", function() {
      // Remove the 'checked' class from all labels
      radioButtons.forEach((rb) => {
        rb.closest('label').classList.remove('checked');
      });
      // Add the 'checked' class to the currently selected radio button's label
      if (radio.checked) {
        radio.closest('label').classList.add('checked');
      }
    });
  });
});